module.exports = __webpack_public_path__ + "media/images/facebook-bd713b9ae0e8ebe7093173634c909558.png";